import { fetcher } from "helpers/fetcher";

import { TGetUserAccessRightReq, TGetUserAccessRightRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUserAccessRight = async (payload?: TGetUserAccessRightReq) => {
  return await fetcher<TGetUserAccessRightRes, TGetUserAccessRightReq["data"]>(
    ENDPOINT.MANAGEMENT.GET_USER_ACCESS_RIGHT,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_USER_ACCESS_RIGHT.version,
        [API_HEADER.BU_ID]: payload?.idBu,
      },
      params: payload?.data,
    }
  );
};

export const queryGetUserAccessRight = async (
  payload?: TGetUserAccessRightReq
) => {
  return (await getUserAccessRight(payload)).data;
};

queryGetUserAccessRight._key = (payload?: TGetUserAccessRightReq) => [
  ENDPOINT.MANAGEMENT.GET_USER_ACCESS_RIGHT.url,
  payload,
];
